module.exports = __webpack_public_path__ + "img/logo_left_top.7e6bdd5b.png";